import { ICandidate, IElection } from 'store/reducers/elections/types';
import { ElectionOutcome, ResultRow } from 'components/redesign/ResultsList';

export interface ElectionTurnout {
    students_count: number;
    votes_count: number;
}

export interface CandidateWithVotes extends ICandidate {
    votes_count?: number;
}

export interface ElectionWithResults extends IElection {
    candidates: CandidateWithVotes[];
    turnout?: ElectionTurnout;
    against_all_votes?: number;
}

function percentOf(votes: number, total: number): number {
    return total > 0 ? Math.round((votes / total) * 100) : 0;
}

function candidateRow(candidate: CandidateWithVotes, total: number): ResultRow {
    return {
        kind: 'candidate',
        key: `c${candidate.id}`,
        name: `${candidate.first_name} ${candidate.last_name}`,
        sub: `курс ${candidate.course}, ${candidate.group.name}`,
        picture: candidate.picture,
        votes: candidate.votes_count || 0,
        percent: percentOf(candidate.votes_count || 0, total),
        isLeader: false,
    };
}

function againstAllRow(votes: number, total: number): ResultRow {
    return {
        kind: 'against-all',
        key: 'against-all',
        name: 'Против всех',
        votes,
        percent: percentOf(votes, total),
        isLeader: false,
    };
}

function withLeaders(rows: ResultRow[], maxVotes: number): ResultRow[] {
    return rows.map(row => ({ ...row, isLeader: row.votes === maxVotes }));
}
export function computeOutcome(
    election: ElectionWithResults
): ElectionOutcome | undefined {
    if (
        !election.show_results ||
        Date.now() < Date.parse(election.date_end) ||
        election.against_all_votes === undefined
    )
        return undefined;
    const total =
        election.candidates.reduce(
            (sum, candidate) => sum + (candidate.votes_count || 0),
            0
        ) + election.against_all_votes;
    const unsorted = [
        ...election.candidates.map(candidate => candidateRow(candidate, total)),
        againstAllRow(election.against_all_votes, total),
    ];
    const maxVotes = Math.max(...unsorted.map(row => row.votes));
    const rows = withLeaders(unsorted, maxVotes).sort(
        (a, b) => b.votes - a.votes
    );
    const leaders = rows.filter(row => row.isLeader);

    if (leaders.length > 1) {
        return { status: 'tie', rows, tied: leaders };
    }
    const [winner] = leaders;
    if (winner.kind === 'against-all') {
        return { status: 'void', rows, leader: winner };
    }
    return { status: 'winner', rows, winner };
}
